import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';
import { Encabezado } from './Encabezado';

const CONCURSOS = [
    {
        imagen: '/assets/img/concursos/900x450/c1.jpg',
        alt: 'Concurso Alumnos Septiembre 2020',
        titulo: 'Alumnos y Alumnas ganan con Red Itmex',
        descripcion: 'Toma una foto creativa enseñándonos cómo recibes tus clases a través de Internet y participa para ganar fabulosos premios.',
        fecha: 'Septiembre 07',
        to: '/c/concurso-septiembre-2020',
    },
    {
        imagen: '/assets/img/concursos/900x450/c2.jpg',
        alt: 'Concurso Maestros Septiembre 2020',
        titulo: 'Maestros y Maestras ganan con Red Itmex',
        descripcion: 'Toma una foto enseñándonos cómo impartes tus clases de manera creativa a través de Internet y participa para ganar fabulosos premios.',
        fecha: 'Septiembre 07',
        to: '/c/concurso-septiembre-2020',
    },
];

class Concursos extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Concursos">
                    <section className="paginaItmex">
                        <Encabezado
                            etiqueta="Concursos"
                            titulo="¡Participa y gana!"
                            subtitulo="Entérate de los nuevos concursos siguiéndonos en nuestras redes sociales."
                        />
                        <div className="concursosItmex-grid">
                            {CONCURSOS.map(c => (
                                <Link key={c.titulo} className="concursoItmex" to={c.to}>
                                    <div className="concursoItmex-imagen">
                                        <img src={c.imagen} alt={c.alt} loading="lazy" />
                                    </div>
                                    <div className="concursoItmex-cuerpo">
                                        <span className="promoItmex-aplica"><i className="far fa-calendar mr-1"></i>{c.fecha}</span>
                                        <h2 className="podcastItmex-titulo">{c.titulo}</h2>
                                        <p className="podcastItmex-descripcion">{c.descripcion}</p>
                                        <span className="planItmex-cta">
                                            Ver concurso
                                            <span className="planItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </section>
                </Layout>
            </div >
        )
    }
};
export default Concursos;
